/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import { IconClose } from "../Ui/Icon";

import { useSelector, useDispatch } from "react-redux";
import { uiAction } from "../../store/ui-gemini";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getPlans,
  saveSubscriptionData,
  approveSubscriptionData,
} from "../../store/subscription-action";
import PlanCard from "./PlanCard";
import LoadingOverlay from "../Ui/LoadingOverlay";
import { SUBSCRIPTION_TYPE, PLAN_STATUS } from "../../constants/index";

const CustomVoice = () => {
  const userDetails = useSelector((state) => state.user.user);
  const isLogin = useSelector((state) => state.auth.isLogin);
  const [isRetrying, setIsRetrying] = useState(false);
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [selectType, setSelectedType] = useState("subscription");
  const [displayPlans, setDisplayPlans] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isShowCustomVoiceAddon = useSelector(
    (state) => state.ui.isShowCustomVoiceAddon
  );
  const close = () => {
    dispatch(uiAction.toggleCustomVoiceAddon());
  };

  const switchType = (value) => {
    setSelectedType(value);
  };
  useEffect(() => {
    if (userDetails.voiceSubscription?.planId) {
      setSelectedType("buymore");
    }
  }, [userDetails.voiceSubscription]);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      if (selectType === "buymore") {
        setDisplayPlans([
          {
            usageType: "BUYMORE",
          },
        ]);
      } else {
        setDisplayPlans(plans);
      }
      setLoading(false);
    }, 1000);
  }, [selectType, plans]);

  useEffect(() => {
    const fetchPlans = async () => {
      setLoading(true);
      const data = await getPlans({
        sortBy: "order",
        sortType: "ASC",
        status: PLAN_STATUS.ACTIVE,
        type: SUBSCRIPTION_TYPE.CUSTOM_VOICE,
      });

      setPlans(data?.data);

      setLoading(false);
    };
    fetchPlans();
  }, [userDetails]);

  const currentPlanId = (planId) => {
    return userDetails.voiceSubscription?.planId;
  };

  const onInit = async (data, actions) => {
    if (!isLogin) {
      actions.disable(); // Disables the PayPal button
    } else {
      actions.enable();
    }
  };

  const onCancel = async (data, actions) => {
    setLoading(false);
  };

  const isOverPlanLimit = () => {
    return userDetails.voiceSubscription?.planId;
    // && userDetails.voiceDownloadCount >= userDetails.voicePlanLimit?.count
  };

  const handleCreate = async (data, actions, planId) => {
    setLoading(true);
    try {
      const subscriptionID = await actions.subscription.create({
        plan_id: planId,
        custom_id: userDetails.id,
        auto_renewal: true,
        application_context: {
          return_url: "http://localhost:3000/return",
          cancel_url: "http://localhost:3000/cancel",
        },
      });

      const subscriptionData = {
        subscriptionId: subscriptionID,
        planId,
        type: SUBSCRIPTION_TYPE.CUSTOM_VOICE,
      };
      await saveSubscriptionData(subscriptionData);
      return subscriptionID;
    } catch (error) {
      actions?.disable();
      setLoading(false);
      toast.error(
        "Something when wrong, please try again or contact our support."
      );
      return null;
    }
  };
  const handleApprove = async (data, actions) => {
    setLoading(true);
    const subscriptionData = {
      subscriptionId: data.subscriptionID,
    };

    try {
      await approveSubscriptionData(subscriptionData);
      setTimeout(() => {
        setLoading(false);
        navigate("/subs/thank-you");
      }, 2000);
    } catch (error) {
      setLoading(false);
      toast.error(
        "Something when wrong, please try again or contact our support."
      );
    }
  };
  // eslint-disable-next-line no-undef
  const planFrag = useMemo(() => {
    return (
      <div className="flex flex-col justify-center gap-4 px-3 py-3 md:min-h-[30rem] md:flex-row md:gap-0 md:py-0">
        {displayPlans?.map((plan, index) => (
          <PlanCard
            key={index}
            onInit={onInit}
            plan={plan}
            userDetails={userDetails}
            handleCreate={handleCreate}
            handleApprove={handleApprove}
            isRetrying={isRetrying}
            currentPlanId={currentPlanId()}
            onCancel={onCancel}
          />
        ))}
      </div>
    );
  }, [userDetails, isRetrying, currentPlanId, plans, handleApprove]);

  return (
    isShowCustomVoiceAddon && (
      <div
        onClick={close}
        className="modal flex overflow-y-auto overflow-x-hidden fixed inset-0 bg-gray-700 bg-opacity-75 z-[6] justify-center items-center w-full max-h-full"
      >
        <div
          className="relative p-4 w-full max-w-4xl max-h-full"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <div className="flex items-center justify-between border-b px-2 rounded-t dark:border-gray-600">
              {/* <h3 className="text-xl font-semibold text-black dark:text-white">
                Tutorial
              </h3> */}
              <button
                type="button"
                className="z-[7] text-gray-400 bg-transparent hover:bg-gray-200 hover:text-black rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={close}
              >
                <IconClose />
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div>
              <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
                <div className="flex flex-col w-full min-h-16 my-5 justify-center items-center gap-3">
                  {isOverPlanLimit() && (
                    <p className="md:px-10 text-start">
                      You've Used All Your Voice Credits It looks like you've
                      reached the limit of voice usage included in your current
                      plan. To continue enjoying Voice service, please purchase
                      additional voice credits below.
                    </p>
                  )}
                  <h1 className="text-3xl font-bold text-gray-700">
                    Upgrade your custom voice plan
                  </h1>
                </div>

                <div className="flex space-x-2 mb-1 border-[3px] border-blue-400-400 rounded-xl select-none">
                  <label className="radio flex flex-grow items-center justify-center rounded-lg p-1 cursor-pointer">
                    <input
                      type="radio"
                      name="radio"
                      value="subscription"
                      className="peer hidden"
                      checked={selectType === "subscription"}
                      onChange={(e) => {
                        switchType(e.target.value);
                      }}
                    />
                    <span className="tracking-widest peer-checked:bg-gradient-to-r peer-checked:from-[#A0C7E7] peer-checked:to-[#4fa5ec] peer-checked:text-white text-gray-700 p-2 rounded-lg transition duration-150 ease-in-out">
                      Subscription
                    </span>
                  </label>

                  <label className="radio flex flex-grow items-center justify-center rounded-lg p-1 cursor-pointer">
                    <input
                      type="radio"
                      name="radio"
                      value="buymore"
                      class="peer hidden"
                      checked={selectType === "buymore"}
                      onChange={(e) => {
                        switchType(e.target.value);
                      }}
                    />
                    <span class="tracking-widest peer-checked:bg-gradient-to-r peer-checked:from-[#4fa5ec] peer-checked:to-[#A0C7E7] peer-checked:text-white text-gray-700 p-2 rounded-lg transition duration-150 ease-in-out">
                      Buy One Time
                    </span>
                  </label>
                </div>

                {planFrag}
                {loading && <LoadingOverlay />}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default CustomVoice;
